import { AttractionContent } from '@routellers/types/dist/city-attraction/attraction-content';
import { CityAttractionLocaleRO } from '@routellers/types/dist/city-attraction/city-attraction-locale.ro';
import { AttractionFunFactKindEnum } from '@routellers/types/dist/city-attraction/enum/attraction-fun-fact-kind.enum';
import { AttractionLocaleStatusEnum } from '@routellers/types/dist/city-attraction/enum/attraction-locale-status.enum';
import { Languages } from '@routellers/types/dist/shared/enum/languages.enum';

export type LocaleDraft = {
    experienceJson: string;
    title: string;
    description: string;
    knownFor: string;
    hoursNote: string;
    priceNote: string;
    visitNote: string;
    content: AttractionContent;
    guideAudioUrl: string | null;
    guideAudioDurationSec: number | null;
    status: AttractionLocaleStatusEnum;
};

export const emptyContent = (): AttractionContent => ({
    hook: '',
    cards: [
        { emoji: '📍', title: '', body: '' },
        { emoji: '🏛', title: '', body: '' },
    ],
    guideTalk: '',
    funFact: { emoji: '✨', title: '', body: '', kind: AttractionFunFactKindEnum.FACT },
    lookFor: ['', ''],
});

export const emptyLocaleDraft = (): LocaleDraft => ({
    experienceJson: '',
    title: '',
    description: '',
    knownFor: '',
    hoursNote: '',
    priceNote: '',
    visitNote: '',
    content: emptyContent(),
    guideAudioUrl: null,
    guideAudioDurationSec: null,
    status: AttractionLocaleStatusEnum.EMPTY,
});

export const findLocale = (locales: CityAttractionLocaleRO[] | undefined, language: Languages) =>
    locales?.find((l) => l.language === language);

export const localeToDraft = (
    locale: CityAttractionLocaleRO | undefined,
    fallbackTitle = '',
): LocaleDraft => ({
    experienceJson: locale?.experience ? JSON.stringify(locale.experience, null, 2) : '',
    title: locale?.title || fallbackTitle,
    description: locale?.description || '',
    knownFor: locale?.knownFor || '',
    hoursNote: locale?.hoursNote || '',
    priceNote: locale?.priceNote || '',
    visitNote: locale?.visitNote || '',
    content: locale?.content || emptyContent(),
    guideAudioUrl: locale?.guideAudioUrl ?? null,
    guideAudioDurationSec: locale?.guideAudioDurationSec ?? null,
    status: locale?.status || AttractionLocaleStatusEnum.EMPTY,
});

export const hasLocaleContent = (content?: AttractionContent | null) =>
    !!content?.hook?.trim() ||
    !!content?.guideTalk?.trim() ||
    (content?.cards || []).some((c) => c.body?.trim() || c.title?.trim());
